import React, { useState, useEffect } from "react";
import { Button, Text } from "components";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { selectStyle } from "styles/actionbuttonCustomStyle.";

const WorkStationOperationAdd = () => {
  const [visible, setvisible] = useState(true);
  const [workstation, setWorkstation] = useState([]);
  const [erplist, setErplist] = useState([]);
  let navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const item_name = location.state?.name;
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  useEffect(() => {
    WorkstationGet();
  }, []);

  const Workstation_obj = {};
  const WorkstationGet = () => {
    axios
      .post("/api/purple-fusion/workstation/get", Workstation_obj, headers)
      .then((response) => {
        setWorkstation(response.data);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const formik = useFormik({
    initialValues: {
      operation_id: id ? id : "",
      workstation_id: [], // Change to an array
      isdefault: "",
    },
    validationSchema: Yup.object().shape({
      workstation_id: Yup.array()
        .min(1, "Please Select at least one Workstation")
        .required("Please Select Workstation Name"),
      isdefault: Yup.string().required("Please Select Default status"),
    }),
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const handleFormSubmit = (values) => {
    const payload = values.workstation_id.map((wsId) => ({
      operation_id: values.operation_id,
      workstation_id: wsId,
      isdefault: values.isdefault,
    }));

    console.log("Final Payload:", payload);

    axios
      .post(
        "/api/purple-fusion/operationworkstation/workstation/create",
        payload,
        headers
      )
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setvisible(false);
                if (!id) {
                  navigate(`/operationdetails/${id}`);
                } else {
                  navigate(`/operationdetails/${id}`, {
                    state: { name: item_name },
                  });
                }
              },
            })
          : toast.error(message, { autoClose: 2000 });
      })
      .catch((error) => {
        console.log(error);
        navigate("*");
      });
  };

  const customStyles = {
    content: {
      width: "60%",
      height: "50%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      // zIndex: 999,
    },
  };
  return (
    <>
      {erplist.some((item) => item.erp_module_id === 44 && item.add) ? (
        <div>
          <div>
            <Modal isOpen={visible} style={customStyles}>
              <form onSubmit={formik.handleSubmit}>
                <div className="bg-white-A700 flex flex-col font-inter items-center justify-start  w-full">
                  <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                    <div className="flex flex-1 flex-col gap-[6px] justify-start md:px-5 w-full">
                      <div className="flex flex-row w-[100%]">
                        <div className="flex flex-row sm:gap-10 items-center justify-start w-full mt-0">
                          <Text
                            className="mt-[-20px]  text-base text-black-900 tracking-[0.20px] "
                            size="txtInterMedium24"
                          >
                            {`Add Workstations For ${item_name}`}
                          </Text>
                        </div>
                        <div className="flex flex-row items-center  justify-end mt-0">
                          <Button
                            className="cursor-pointer font-small mb-2 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
                            shape="round"
                            color="blue_A700"
                            size="base"
                            variant="fill"
                            type="submit"
                          >
                            Save
                          </Button>
                          <Button
                            className="cursor-pointer sticky font-small mb-3 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                            shape="round"
                            color="white"
                            size="base"
                            variant="fill"
                            onClick={() => {
                              setvisible(false);
                              navigate(`/operationdetails/${id}`, {
                                state: { name: item_name },
                              });
                            }}
                          >
                            ╳
                          </Button>
                        </div>
                      </div>
                      <div className="flex flex-col items-center justify-start md:ml-[0]  w-[87%] md:w-full  ">
                        <ToastContainer />
                        <div className="flex flex-col items-center justify-start mt-2 w-full">
                          <div className="md:gap-5  gap-x-[75px] gap-y-4 grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full">
                            <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full">
                              <Text
                                className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                                size="txtInterMedium20Black900"
                              >
                                <span className="text-black-700 font-inter font-small text-sm">
                                  Workstation Name
                                </span>
                                <span className="text-red-A700 font-inter font-small text-sm">
                                  *
                                </span>
                              </Text>
                              <Select
                                name="workstation_id"
                                options={workstation.map((resstate) => ({
                                  label: resstate.name,
                                  value: resstate.id,
                                }))}
                                isMulti // Enable multiple selection
                                className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                                onChange={(selectedOptions) => {
                                  formik.setFieldValue(
                                    "workstation_id",
                                    selectedOptions.map(
                                      (option) => option.value
                                    )
                                  );
                                }}
                                maxMenuHeight={150} // Limit the number of visible options
                                menuShouldScrollIntoView={false} // Prevent auto-scrolling
                                onBlur={formik.handleBlur}
                                placeholder="Select Workstation(s)"
                              />
                              {formik.touched.workstation_id &&
                              formik.errors.workstation_id ? (
                                <div className="text-red-500 text-sm">
                                  {formik.errors.workstation_id}
                                </div>
                              ) : null}
                            </div>

                            <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full">
                              <Text
                                className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                                size="txtInterMedium20Black900"
                              >
                                <span className="text-black-700 font-inter font-small text-sm">
                                  Is Default Operation ?
                                </span>
                                <span className="text-red-A700 font-inter font-small text-sm">
                                  *
                                </span>
                              </Text>
                              <div className="flex items-center">
                                <label className="ml-2">
                                  <input
                                    type="radio"
                                    name="isdefault"
                                    value="true"
                                    className="mr-2"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                  />
                                  Yes
                                </label>
                                <label className="ml-2">
                                  <input
                                    type="radio"
                                    name="isdefault"
                                    value="false"
                                    className="mr-2 ml-2"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                  />
                                  No
                                </label>
                              </div>
                              {formik.touched.isdefault &&
                              formik.errors.isdefault ? (
                                <div className="text-red-500 text-sm">
                                  {formik.errors.isdefault}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </Modal>
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
};

export default WorkStationOperationAdd;
